<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="employee_payment_method"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="paymentMethodForm"
          :redirect-detail="false"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Metode Pembayaran Karyawan"
          addButton="Tambah Metode Pembayaran"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>

        <b-modal
          ref="myModalRef"
          id="addModals"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          size="lg"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center" v-if="!isEdit">Tambah Metode Pembayaran Baru</h3>
            <h3 class="text-center" v-else-if="isEdit">Ubah Metode Pembayaran</h3>
          </div>

          <b-form id="paymentMethodForm" validated novalidate>
            <div v-if="!loadingSubmitModal">
              <b-row>
                <b-col sm="4">
                  <b-form-group label-for="name" label="Metode Pembayaran">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="$v.paymentMethodForm.name.$model"
                      :state="!$v.paymentMethodForm.name.$invalid"
                      required
                      placeholder="Metode Pembayaran"
                    ></b-form-input>
                    <b-form-invalid-feedback>Metode Pembayaran harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group label-for="description" label="Deskripsi">
                    <b-form-textarea
                      id="description"
                      :rows="3"
                      :max-rows="6"
                      v-model="$v.paymentMethodForm.description.$model"
                      :state="!$v.paymentMethodForm.description.$invalid"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>Deskripsi harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <loading></loading>
            </div>
          </b-form>

          <div slot="modal-footer" class="float-right">
            <div v-if="!loadingSubmitModal">
              <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="button"
                size="sm"
                variant="primary"
                @click="saveProcess"
                :disabled="$v.paymentMethodForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </div>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import masterInterfaces from "@/templates/_master_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "employee_payment_method",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      employee_payment_method: [],
      loading: true,
      loadingSubmitModal: false,
      fields: [
        {
          key: "name",
          label: "Metode Pembayaran",
          class: "width-250",
          sortable: true
        },
        { key: "description", label: "Deskripsi" },
        { key: "action", class: "width-50 text-center" }
      ],
      paymentMethodForm: masterInterfaces.payment_method,
      isEdit: false
    };
  },
  validations: {
    paymentMethodForm: {
      name: { required },
      description: {}
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.getPaymentMethod();
    },
    getPaymentMethod: function() {
      this.axios
        .get("web/master/employee/payment_method/all/")
        .then(response => {
          this.employee_payment_method = response.data.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function(e) {
      this.isEdit = true;
      this.resetForm();
      this.paymentMethodForm = e;
    },
    resetForm: function() {
      for (var a in masterInterfaces.payment_method) {
        masterInterfaces.payment_method[a] = null;
      }
      this.paymentMethodForm = masterInterfaces.payment_method;
    },
    cancelAdd: function() {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.init();
    },
    saveProcess: function(evt) {
      evt.preventDefault();
      if (this.isEdit) {
        if (confirm("Apakah anda ingin mengubah divisi ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .put("web/master/employee/payment_method/edit/", this.paymentMethodForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Divisi Berhasil",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan divisi ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .post("web/master/employee/payment_method/add/", this.paymentMethodForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Divisi Berhasil",
                  message: response.data.message
                });
              } else {
                this.showErrorNotification({
                  title: "Tambah Divisi Gagal",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      }
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Master Divisi Karyawan",
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

  